import request from "../../../infra/request";

export const downloadErrorResultFile = async (id, aiOcr) => {
  if (!id) {
    return { error: new Error("The file id can not be empty") };
  }
  try {
    const response = await request.get(`/admin/error-results/file/${id}?aiOcr=${aiOcr}`);
    return { data: response.data };
  } catch (error) {
    return {
      error: {
        message: error.message,
        code: error.response?.code || error.response?.statusText,
        status: error.response?.status,
      },
    };
  }
};
